import Vue from "vue";
import Vuex from "vuex";
import api from "@/api";
Vue.use(Vuex);
import CONSTANTS from "@/store/constants";
import moment from "moment";
import FORMS_OPTIONS from "./FormsOptions";
import supplierRequestMixin from "../mixins/supplierRequestMixin";
/* eslint-disable */
const state = {
	decisionBranches:{
		sections:[],
		cards:[],
		cardDecisionBranches:[]
	},
	categoryAccessMethods :{
		clicked : false,
		isAccessedViaDeeplink : true
	},
	invoiceCategoryAccessMethods :{
		clicked : false,
		isAccessedViaDeeplink : true
	},
	watchers :[],
	isCompanyBuyingServicesOthersSelected :false,
	currentUser: {},
	authToken: null,
	authResponse: {},
	cognitoAccessToken: '',
	isLoading: false,
	errorMessage: undefined,
	errorDetail : undefined,
	currentAlias: CONSTANTS.GUIDES_ALIAS,
	currentAppData: null,
	searchKeyword: null,
	currentSubCategory: null,
	successMessage: undefined,
	breadcrumbItems: [],
	allCategories: [],
	historyArray: [],
	currentCategory: null,
	searchResult: null,
	isComponentRequest: false,
	suppliers: [],
	userData: {},
	products: [],
	quickSolutions: [],
	supplierCountryList: [],

	// OneIntake form vuex states
	tabItems: [
		{
			name: "General information",
			component: "GeneralInformation",
			icon: "info-circle",
		},
		{
			name: "Supplier information",
			component: "SupplierInformation",
			icon: "address-card",
		},
		{
			name: "Data and security",
			component: "AdditionalDetails",
			icon: "shield-alt",
		},
		{ name: "Preview details", component: "PreviewDetails", icon: "eye" },
	],
	currentTab: "",
	supplierOnboardRequestData: {
		companyBuyingServiceCheckBox: [],
		watcherUserIds : "",
		attachments: [],
		diverseSupplierConsidered: undefined,
		technologyFromReseller: "",
		corporateCardPayment: "",
		customerDataProcessed: "",
		productDescription: "",
		approximateSpend: "",
		needHelpWithSupplier: undefined,
		productName: "",
		businessJustification: "",
		requestedBy: "",
		//deleting requestedByFullName before sending to backend
		requestedByFullName: "",
		requestedFor: "",
		//deleting requestedForFullName before sending to backend
		requestedForFullName: "",
        // supplier data
        supplierName: "",
        supplierWebsite: "",
		supplierContactRole: "",
		supplierContactName: "",
		supplierContactEmail: "",
		supplierCountry: "",
        //reseller data
        resellerName:"",
		personalDataProcessed: undefined,
		integrateWithADSKNetwork: undefined,
		integrateWithADSKProduct: undefined,
		developAutodeskProductCode : undefined,
		thirdPartyLicenseRequired: undefined,
		cookieInstalledOnADSKNetwork: undefined,
		masterAgreementExists: "",
		deliveredWithInYear: undefined,
		purchaseType: undefined,
		serviceType: "",
		category: "",
		service: "",
		supplierEmployeeCountBelowFive: undefined,
		requestedStartDate: undefined,
		companyBuyingServices: [],
		supplierLocatedInUSCanadaUK: undefined,
		supplierLocated: undefined,
		requestSubmissionType: "",
		recommendedByGovernment: undefined,
		onBehalfOfAutodeskCustomer: undefined,
		anyRelationshipWithAutodesk: undefined,
		artificialIntelligenceOrMachineLearning: undefined,
		customerIntellectualProperty: undefined,
		softwareInstalledOnADSKMachine: "",
		generativeAI : "",
		genAIAttestationSubmitted: undefined,
		isPilotOrProofOfConcept: undefined,
		duplicateForm: false
	},
	/* Keeping first letter of text lower case because text and value cannot be exactly the same */
	/* Overriding first letter via css, ref: @assets/stylesheets/vueSearchSelectOverrides.css */
	/* Ref github issue: https://github.com/moreta/vue-search-select/issues/112 */
	supplierServiceType: [
		{ value: "Tax Services", text: "tax services" },
		{ value: "Audit Services", text: "audit services" },
		{ value: "Legal Services", text: "legal services" },
		{ value: "None of the above", text: "none of the above" },
	],
	supplierContactRoleOptions: [
		{ value: "account_rep", text: "Account rep" },
		{ value: "business_continuity", text: "Business continuity" },
		{ value: "compliance", text: "Compliance" },
		{ value: "finance", text: "Finance" },
		{ value: "information_security", text: "Information security" },
		{ value: "legal", text: "Legal" },
		{ value: "quality", text: "Quality" },
		{ value: "sales", text: "Sales" },
		{ value: "other", text: "Other" },
	],
    supplierPurchaseTypeOptions: [
		{ value: "Goods", text: "goods" },
		{ value: "Services", text: "services" },
		{ value: "Goods&Services", text: "goods and Services" },
	],
	supplierServiceCategoryOptions: [
		{ value: "Technology", text: "technology" },
		{ value: "Facilities", text: "facilities" },
		{ value: "Human Resources", text: "human resources" },
		{ value: "Marketing", text: "marketing" },
		{ value: "Travel & Events", text: "travel & Events" },
		{ value: "Professional Services", text: "other professional services" },
		{ value: "autodesk sales consulting engagements", text: "Autodesk Sales Consulting Engagements" },
        { value: "sponsorship", text: "Sponsorship" },
        { value: "corporate donation", text: "Corporate donation" },
        { value: "rent/utilities", text: "Rent/utilities" },
        { value: "legal services", text: "Legal services" }
	],
	supplierServiceOptions: [
		{ value: "One-time Speakers", text: "one-time speakers" },
		{ value: "Influencers", text: "influencers" },
		{ value: "Software", text: "software" },
		{ value: "Goods", text: "goods" },
		{ value: "Venues/events/travel", text: "venues/events/travel" },
		{ value: "Licensing Agreements", text: "licensing Agreements" },
		{ value: "Photographers/Videographers", text: "photographers/videographers (if not going into Autodesk sites or product)" },
		{ value: "Facility Services", text: "facility services" },
		{ value: "Physical trainers", text: "physical trainers (yoga instructors, nutritionists, etc.)" },
		{ value: "Non-professional services", text: "non-professional services (artists, face painters, dancers, DJs, etc.)" },
		{ value: "None of the above", text: "none of the above" }
	],
	isRequestingForOthers: false,
	isRequestingForWatchers: false,
	draftId: "",
	returnedRequestId: "",
	supplierDraftData: [],
	isSupplierNameLoaded: false,
	onBoardingPendingRequests: [],
	onBoardingCompletedRequests: [],
	onBoardingReturnedRequests: [],
	caseDetails: {},
	adskContactInfo: [],
	showSearchSpinner: false,
	purchaseOrdersFormattedList: [],
	formattedInvoices: [],
	adminAPUserList : [],
	adminDataList : {
		companyBusinessPlaceList : [],
		companyCodeList : [],
		countryCodeList :[],
		countryList : [],
		countryStateList : [],
		currencyList : [],
		expenseTypeCodeOptions : [],
		expenseTypeTextOptions : [],
		companyCodeTextOptions: [],
		companyCodeOptions: [],
	},
	autocompleteCompanyCodeAndNameList : [],

	// PO  Based payment data form object
	nonPOPaymentData: {},

	// PO basedPayment data
	poBasedPaymentData: {},

	// One time supplier payment data
	oneTimeSupplierPayment: {},

	//Advanced POBased payment data
	advPOBasedPayment: {},

	// Used by all the forms to ensure if back nav is clicked to not reset the data on mount
	isFormDataLoaded: false,

	// prevent user from proceeding upon entering an invalid PONumber
	isInvalidPoNumber: true,

	formValidationErrors: [],

	// Invoice submission form data
	invoiceSubmissionData: {},

	//preserve invoice table state (sort, filter, pagination user preferences)
	invoicesTableUserPreferences: {},

	//preserve invoice table state (sort, filter, pagination user preferences)
	poTableUserPreferences: {},

	exceptionSubmissionRequestData: {
		companyBuyingServices: [],
		companyBuyingServiceCheckBox: [],
		stringifiedWatchers: [],
	 	watchers: [],
		formStatus: '',
		isRequestingForOthers: undefined,
		isRequestingForWatchers: undefined,
		isCompanyBuyingServicesOthersSelected: undefined,
		stepsCompletedForSponsorship: undefined,
		necessaryStepsAndSupportingDocumentationCompleted: undefined,
		stepsCompletedForCorporateDonation: undefined,
		approvalAgreementAvailableForSpeaker: undefined,
		recommendedByGovernment: undefined,
		onBehalfOfAutodeskCustomer: undefined,
		anyRelationshipWithAutodesk: undefined,
		needHelpWithSupplier: undefined,
		corporateCardType:undefined
	},

	prevRoute: '',

	isModalOpenFromBreadcrumbBtn: false,

	viewingAPUserDataFor: '',

	isAPAdmin: false,

	invoiceDraftRecords: [],

	invoiceSubmissionStatusRecords: [],

	deleteDraftErrorMessage: '',

	isContinueDraftClicked: false,

	isInvoicesAndDraftsCached: false,

	bankDetailsDropdownValues: [],

	isBankDetailsCheckedAsHidden : false,

	rolesToNamesMap: [],

	apUserId: '',

	isNamesFilterLoading: false,

	rolesObj : {
		"requestedBy" : "Requested by",
		"createdBy" : "Created by",
		"costCenterOwner" : "Cost Center owner",
		"costCenterFbp" : "Cost Center finance business partner"
	},

	poFiltersList: {
		costCenterList: [],
		supplierNameList: [],
		usersList: [],
		statusList: [],
		isFiltersReloaded: false,
	},

	ritmStatusAccessPoint: '',

	invoicesDirectReports: [],

	invoicesRolesList: [],

	INVOICES_FILTER_ROLES: {},

	supplierOnBoardingStatus: [],

	// supplier names list for autocomplete

	suppliersNameList: [],

	requesterCountryBuyingService: [],

	isSupplierNameSheetUpdated: false,
};

/* eslint-disable no-shadow */
const getters = {
	invoiceCategoryAccessMethods(state){
		return state.invoiceCategoryAccessMethods
	},
	autocompleteCompanyCodeAndNameList(state){
		return state.autocompleteCompanyCodeAndNameList
	},
	decisionBranches(state){
		return state.decisionBranches;
	},
	categoryAccessMethods(state){
		return state.categoryAccessMethods
	},
	adminAPUserList(state){
		return state.adminAPUserList
	},
	supplierCountryList(state){
		return state.supplierCountryList
	},
	adminDataList(state){
		return state.adminDataList
	},
	isBankDetailsCheckedAsHidden(state){
		return state.isBankDetailsCheckedAsHidden
	},
	bankDetailsDropdownValues(state){
		return state.bankDetailsDropdownValues
	},
	isCompanyBuyingServicesOthersSelected(state){
		return state.isCompanyBuyingServicesOthersSelected
	},
	cognitoAccessToken(state) {
		return state.cognitoAccessToken
	},
	watchers(state){
		return state.watchers
	},
	quickSolutions(state) {
		return state.quickSolutions;
	},
	suppliers(state) {
		return state.suppliers;
	},
	products(state) {
		return state.products;
	},
	currentAlias(state) {
		return state.currentAlias;
	},
	allCategories(state) {
		return state.allCategories;
	},
	breadcrumbItems(state) {
		return state.breadcrumbItems;
	},
	searchKeyword(state) {
		return state.searchKeyword;
	},
	currentAppData(state) {
		return state.currentAppData;
	},
	currentSubCategory(state) {
		return state.currentSubCategory;
	},
	isLoading(state) {
		return state.isLoading;
	},
	isComponentRequest(state) {
		return state.isComponentRequest;
	},

	errorMessage(state) {
		return state.errorMessage;
	},
	errorDetail(state) {
		return state.errorDetail;
	},
	currentUser(state) {
		if (!state.authResponse) return undefined;
		return state.authResponse.user;
	},
	authResponse(state) {
		return state.authResponse;
	},
	authToken(state) {
		return state.authToken;
	},
	successMessage(state) {
		return state.successMessage;
	},
	historyArray(state) {
		return state.historyArray;
	},
	currentCategory(state) {
		return state.currentCategory;
	},
	searchResult(state) {
		return state.searchResult;
	},
	tabItems(state) {
		return state.tabItems;
	},
	currentTab(state) {
		return state.currentTab;
	},
	supplierOnboardRequestData(state) {
		return state.supplierOnboardRequestData;
	},
	supplierServiceType(state) {
		return state.supplierServiceType;
	},
	approximateSpendOptions(state) {
		return state.approximateSpendOptions;
	},
	supplierServiceCategoryOptions(state) {
		return state.supplierServiceCategoryOptions;
	},
	supplierServiceOptions(state) {
		return state.supplierServiceOptions;
	},
	isRequestingForOthers(state) {
		return state.isRequestingForOthers;
	},
	isRequestingForWatchers(state) {
		return state.isRequestingForWatchers;
	},
	draftId(state) {
		return state.draftId;
	},
	supplierDraftData(state) {
		return state.supplierDraftData;
	},
	supplierPurchaseTypeOptions(state) {
		return state.supplierPurchaseTypeOptions;
	},
	isSupplierNameLoaded(state) {
		return state.isSupplierNameLoaded;
	},
	onBoardingPendingRequests(state) {
		return state.onBoardingPendingRequests;
	},
	onBoardingCompletedRequests(state) {
		return state.onBoardingCompletedRequests;
	},
	onBoardingReturnedRequests(state) {
		return state.onBoardingReturnedRequests;
	},
	caseDetails(state) {
		return state.caseDetails;
	},
	adskContactInfo(state) {
		return state.adskContactInfo;
	},
	supplierContactRoleOptions(state) {
		return state.supplierContactRoleOptions;
	},
	showSearchSpinner(state) {
		return state.showSearchSpinner;
	},
	formattedInvoices(state) {
		return state.formattedInvoices
	},
	purchaseOrdersFormattedList(state) {
		return state.purchaseOrdersFormattedList
	},
	nonPOPaymentData(state) {
		return state.nonPOPaymentData
	},
	poBasedPaymentData(state){
		return state.poBasedPaymentData
	},
	isFormDataLoaded(state) {
		return state.isFormDataLoaded
	},
	oneTimeSupplierPayment(state) {
		return state.oneTimeSupplierPayment
	},

	userData(state) {
		return function (userId) {

			if (!state.userData[userId]) {

				var user = {
					userId,
					data: {
						fullName: userId,
						userId:userId
					}
				}
				store.commit("setUserData", user);
				if(userId && userId.length>0){
					api.getUserInfo(userId).then(resp => {
						let userFullName = resp.data.fullName ? resp.data.fullName : userId;
						user.data.fullName = userFullName;
					}).catch(() => {
						user.data.fullName = userId
					}).finally(() => {
						store.commit("setUserData", user);
					});
				}


			}
			return state.userData[userId];
		}
	},
	formValidationErrors(state) {
		return state.formValidationErrors
	},
	advPOBasedPayment(state) {
		return state.advPOBasedPayment
	},
	isInvalidPoNumber(state) {
		return state.isInvalidPONumber
	},
	invoiceSubmissionData(state) {
		return state.invoiceSubmissionData
	},
	exceptionSubmissionRequestData(state) {
		return state.exceptionSubmissionRequestData
	},
	invoicesTableUserPreferences(state) {
		return state.invoicesTableUserPreferences
	},
	poTableUserPreferences(state) {
		return state.poTableUserPreferences
	},
	prevRoute(state) {
		return state.prevRoute
	},
	isModalOpenFromBreadcrumbBtn(state) {
		return state.isModalOpenFromBreadcrumbBtn
	},
	viewingAPUserDataFor(state) {
		return state.viewingAPUserDataFor
	},
	invoiceDraftRecords(state){
		return state.invoiceDraftRecords
	},
	invoiceSubmissionStatusRecords(state){
		return state.invoiceSubmissionStatusRecords
	},
	isAPAdmin(state) {
		return state.isAPAdmin
	},
	deleteDraftErrorMessage(state) {
		return state.deleteDraftErrorMessage
	},
	isContinueDraftClicked(state) {
		return state.isContinueDraftClicked
	},
	isInvoicesAndDraftsCached(state){
		return state.isInvoicesAndDraftsCached
	},
	rolesToNamesMap(state) {
		return state.rolesToNamesMap
	},
	apUserId(state) {
		return state.apUserId
	},
	isNamesFilterLoading(state) {
		return state.isNamesFilterLoading
	},
	rolesObj(state) {
		return state.rolesObj
	},
	poFiltersList(state) {
		return state.poFiltersList
	},
	returnedRequestId(state) {
		return state.returnedRequestId
	},
	ritmStatusAccessPoint(state) {
		return state.ritmStatusAccessPoint
	},
	invoicesDirectReports(state) {
		return state.invoicesDirectReports
	},
	invoicesRolesList(state) {
		return state.invoicesRolesList
	},
	INVOICES_FILTER_ROLES(state) {
		return state.INVOICES_FILTER_ROLES
	},
	supplierOnBoardingStatus(state) {
		return state.supplierOnBoardingStatus
	},
	suppliersNameList(state) {
		return state.suppliersNameList
	},
	requesterCountryBuyingService(state) {
		return state.requesterCountryBuyingService
	},
	isSupplierNameSheetUpdated(state) {
		return state.isSupplierNameSheetUpdated
	}
	
};

const mutations = {
	setAutocompleteCompanyCodeAndNameList(state,autocompleteCompanyCodeAndNameList){
		state.autocompleteCompanyCodeAndNameList = autocompleteCompanyCodeAndNameList
	},
	setDecisionBranches(state, decisionBranches){
		state.decisionBranches = decisionBranches;
	},
	setInvoiceCategoryAccessMethods(state,invoiceCategoryAccessMethods){
		state.invoiceCategoryAccessMethods = invoiceCategoryAccessMethods
	},
	setCategoryAccessMethods(state,categoryAccessMethods){
		state.categoryAccessMethods = categoryAccessMethods
	},
	setAdminAPUserList(state,adminAPUserList){
		state.adminAPUserList = adminAPUserList
	},
	setAdminDataList(state,adminDataList){
		state.adminDataList = adminDataList
	},
	setSupplierCountryList(state,supplierCountryList){
		state.supplierCountryList = supplierCountryList
	},
	setIsBankDetailsCheckedAsHidden(state,isBankDetailsCheckedAsHidden){
		state.isBankDetailsCheckedAsHidden = isBankDetailsCheckedAsHidden
	},
	setBankDetailsDropdownValues(state,bankDetailsDropdownValues){
		state.bankDetailsDropdownValues = bankDetailsDropdownValues
	},
	setIsCompanyBuyingServicesOthersSelected(state,isCompanyBuyingServicesOthersSelected){
		state.isCompanyBuyingServicesOthersSelected = isCompanyBuyingServicesOthersSelected
	},
	setCognitoAccessToken(state, cognitoAccessToken) {
		state.cognitoAccessToken = cognitoAccessToken
	},
	setWatchers(state,watchers){
		state.watchers = watchers;
	},
	setQuickSolutions(state, quickSolutions) {
		state.quickSolutions = quickSolutions;
	},
	setProducts(state, products) {
		state.products = products;
	},
	setSuppliers(state, suppliers) {
		state.suppliers = suppliers;
	},
	setAllCategories(state, allCategories) {
		state.allCategories = allCategories;
	},
	setBreadcrumbItems(state, breadcrumbItems) {
		state.breadcrumbItems = breadcrumbItems;
	},
	setCurrentAlias(state, currentAlias) {
		state.currentAlias = currentAlias;
	},
	setSearchKeyword(state, searchKeyword) {
		state.searchKeyword = searchKeyword;
	},
	setCurrentAppData(state, currentAppData) {
		state.currentAppData = currentAppData;
	},
	setCurrentSubCategory(state, currentSubCategory) {
		state.currentSubCategory = currentSubCategory;
	},
	setAuthResponse(state, authResponse) {
		state.authResponse = authResponse;
	},
	setAuthToken(state, authToken) {
		state.authToken = authToken;
	},
	setIsLoading(state, isLoading) {
		state.isLoading = isLoading;
	},
	setIsComponentRequest(state, isComponentRequest) {
		state.isComponentRequest = isComponentRequest;
	},

	setErrorMessage(state, errorMessage) {
		state.errorMessage = errorMessage;
	},
	setErrorDetail(state, errorDetail) {
		state.errorDetail = errorDetail;
	},
	setSuccessMessage(state, successMessage) {
		state.successMessage = successMessage;
		setTimeout(() => {
			state.successMessage = null;
		}, 5000);
	},
	setHistoryArray(state, historyArray) {
		state.historyArray = historyArray;
	},
	setCurrentCategory(state, currentCategory) {
		state.currentCategory = currentCategory;
	},
	setSearchResult(state, searchResult) {
		state.searchResult = searchResult;
	},
	setCurrentTab(state, currentTab) {
		state.currentTab = currentTab;
	},
	setRequestedBy(state, requestedBy) {
		state.supplierOnboardRequestData.requestedBy = requestedBy;
	},
	setRequestedFor(state, requestedForObj) {
		state.supplierOnboardRequestData.requestedFor =
			requestedForObj.requestedFor;
		state.supplierOnboardRequestData.requestedForFullName =
			requestedForObj.requestedForFullName;
	},
	setSupplierOnboardRequestData(state, supplierOnboardRequestData) {
		state.supplierOnboardRequestData = supplierOnboardRequestData;
	},
	setIsRequestingForOthers(state, isRequestingForOthers) {
		state.isRequestingForOthers = isRequestingForOthers;
	},
	setIsRequestingForWatchers(state,isRequestingForWatchers) {
		state.isRequestingForWatchers = isRequestingForWatchers
	},
	resetSupplierIntakeData(state) {
		let resetObj = {
			//multiselect has to be set to an empty array , while resetting it back so that the multiselect component gets hold of this property on render.
			companyBuyingServices: [],
			companyBuyingServiceCheckBox: []
		};
		state.supplierOnboardRequestData = resetObj;
	},
	resetExceptionSubmissionRequestData(state) {
		let resetObj = {
			companyBuyingServices : [],
			companyBuyingServiceCheckBox : [],
			watchers : [],
			stringifiedWatchers: [],
			attachments : [],
			isRequestingForOthers : false,
			isRequestingForWatchers : false,
			isCompanyBuyingServicesOthersSelected : false,
			stepsCompletedForSponsorship : false,
			stepsCompletedForCorporateDonation : false,
			approvalAgreementAvailableForSpeaker : false,
		}
		state.exceptionSubmissionRequestData = resetObj;
	},
	setFullName(state, nameObj) {
		if (nameObj.requestedBy) {
			state.supplierOnboardRequestData = {
				...state.supplierOnboardRequestData,
				requestedByFullName: nameObj.fullName,
			};
		} else {
			state.supplierOnboardRequestData = {
				...state.supplierOnboardRequestData,
				requestedForFullName: nameObj.fullName,
			};
		}
	},
	setDraftId(state, draftId) {
		state.draftId = draftId;
	},
	setSupplierNameLoaded(state, isSupplierNameLoaded) {
		state.isSupplierNameLoaded = isSupplierNameLoaded;
	},
	setSupplierName(state, supplierName) {
		state.supplierOnboardRequestData.supplierName = supplierName;
	},
	setNeedHelpWithSupplier(state, needHelpWithSupplier) {
		state.supplierOnboardRequestData.needHelpWithSupplier = needHelpWithSupplier;
	},
	setSupplierWebsite(state, supplierWebsite) {
		state.supplierOnboardRequestData.supplierWebsite = supplierWebsite;
	},
	setSupplierDraftData(state, supplierDraftData) {
		state.supplierDraftData = supplierDraftData;
	},
	setOnBoardingPendingRequests(state, onBoardingPendingRequests) {
		state.onBoardingPendingRequests = onBoardingPendingRequests;
	},
	setOnBoardingCompletedRequests(state, onBoardingCompletedRequests) {
		state.onBoardingCompletedRequests = onBoardingCompletedRequests;
	},
	setOnBoardingReturnedRequests(state, onBoardingReturnedRequests) {
		state.onBoardingReturnedRequests = onBoardingReturnedRequests;
	},
	setCaseDetails(state, caseDetails) {
		state.caseDetails = caseDetails;
	},
	setAdskContactInfo(state, adskContactInfo) {
		state.adskContactInfo = adskContactInfo;
	},
	setShowSearchSpinner(state, showSearchSpinner) {
		state.showSearchSpinner = showSearchSpinner;
	},
	setFormattedInvoices(state, formattedInvoices) {
		state.formattedInvoices = formattedInvoices;
	},
	setPurchaseOrdersFormattedList(state, purchaseOrdersFormattedList) {
		state.purchaseOrdersFormattedList = purchaseOrdersFormattedList;
	},
	setPoBasedPaymentData(state, poBasedPaymentData) {
		state.poBasedPaymentData = poBasedPaymentData
	},
	setNonPOPaymentData(state, nonPOPaymentData) {
		state.nonPOPaymentData = nonPOPaymentData
	},
	setIsFormDataLoaded(state, isFormDataLoaded) {
		state.isFormDataLoaded = isFormDataLoaded
	},
	setOneTimeSupplierPayment(state, oneTimeSupplierPayment) {
		state.oneTimeSupplierPayment = oneTimeSupplierPayment
	},
	setUserData(state, {userId,data}) {
		Vue.set(state.userData, userId, data);
	},
	setFormValidationErrors(state, formValidationErrors) {
		state.formValidationErrors = formValidationErrors
	},
	setAdvPOBasedPaymentData(state, advPOBasedPayment) {
		state.advPOBasedPayment = advPOBasedPayment
	},
	resetFormPaymentData(state, form) {
		state[form].bankName =''
		state[form].bankCountry =''
		state[form].bankAccountNumber =''
		state[form].bankIBAN =''
		state[form].bankNumber =''
		state[form].bankSwiftCode =''
		state[form].payrollPaymentDate =''
		state[form].directDebitDeductionDate =''
	},
	setIsInvalidPoNumber(state, isInvalidPoNumber) {
		state.isInvalidPoNumber = isInvalidPoNumber
	},
	setInvoiceSubmissionData(state, invoiceSubmissionData) {
		state.invoiceSubmissionData = invoiceSubmissionData
	},
	setExceptionSubmissionRequestData(state, exceptionSubmissionRequestData) {
		state.exceptionSubmissionRequestData = exceptionSubmissionRequestData
	},
	setInvoicesTableUserPreferences(state, invoicesTableUserPreferences) {
		state.invoicesTableUserPreferences = invoicesTableUserPreferences
	},
	setPOTableUserPreferences(state, poTableUserPreferences) {
		state.poTableUserPreferences = poTableUserPreferences
	},
	setPrevRoute(state, prevRoute) {
		state.prevRoute = prevRoute
	},
	setIsModalOpenFromBreadcrumbBtn(state, isModalOpenFromBreadcrumbBtn) {
		state.isModalOpenFromBreadcrumbBtn = isModalOpenFromBreadcrumbBtn
	},
	setViewingAPUserDataFor(state, viewingAPUserDataFor) {
		state.viewingAPUserDataFor = viewingAPUserDataFor
	},
	setisAPAdmin(state, isAPAdmin) {
		state.isAPAdmin = isAPAdmin
	},
	setInvoiceDraftRecords(state,invoiceDraftRecords){
		state.invoiceDraftRecords = invoiceDraftRecords
	},
	setInvoiceSubmissionStatusRecords(state,invoiceSubmissionStatusRecords){
		state.invoiceSubmissionStatusRecords = invoiceSubmissionStatusRecords
	},
	setDeleteDraftErrorMessage(state, deleteDraftErrorMessage) {
		state.deleteDraftErrorMessage = deleteDraftErrorMessage
		setTimeout(() => {state.deleteDraftErrorMessage = ''},5000)
	},
	setIsContinueDraftClicked(state, isContinueDraftClicked) {
		state.isContinueDraftClicked = isContinueDraftClicked
	},
	setIsInvoicesAndDraftsCached(state, isInvoicesAndDraftsCached) {
		state.isInvoicesAndDraftsCached = isInvoicesAndDraftsCached
	},
	setRolesToNamesMap(state, rolesToNamesMap) {
		state.rolesToNamesMap = rolesToNamesMap
	},
	setAPUserId(state, apUserId) {
		state.apUserId = apUserId
	},
	setIsNamesFilterLoading(state, isNamesFilterLoading) {
		state.isNamesFilterLoading = isNamesFilterLoading
	},
	setRolesObj(state, rolesObj) {
		state.rolesObj = rolesObj
	},
	setPOFiltersList(state, poFiltersList) {
		state.poFiltersList = poFiltersList
	},
	setReturnedRequestId(state, returnedRequestId) {
		state.returnedRequestId = returnedRequestId
	},
	setRitmStatusAccessPoint(state, ritmStatusAccessPoint) {
		state.ritmStatusAccessPoint = ritmStatusAccessPoint
	},
	setInvoicesDirectReports(state, invoicesDirectReports) {
		state.invoicesDirectReports = invoicesDirectReports
	},
	setInvoicesRolesList(state, invoicesRolesList) {
		state.invoicesRolesList = invoicesRolesList
	},
	setInvoicesFilterRoles(state, invoicesFilterRoles) {
		state.INVOICES_FILTER_ROLES = invoicesFilterRoles
	},
	setSupplierOnBoardingStatus(state, supplierOnBoardingStatus) {
		state.supplierOnBoardingStatus = supplierOnBoardingStatus
	},
	setSuppliersNameList(state, suppliersNameList) {
		state.suppliersNameList = suppliersNameList
	},
	setRequesterCountryBuyingService(state, requesterCountryBuyingService) {
		state.requesterCountryBuyingService = requesterCountryBuyingService
	},
	setIsSupplierNameSheetUpdated(state, isSupplierNameSheetUpdated) {
		state.isSupplierNameSheetUpdated = isSupplierNameSheetUpdated
	}
};
const actions = {
	clearAllFormsData({ commit }) {
		commit("resetSupplierIntakeData");
		commit("setSupplierNameLoaded", false);
		commit("setIsRequestingForOthers", false);
		commit("setCaseDetails", {});
		commit("setAdskContactInfo", []);
		commit("setWatchers",[]);
		commit("setIsRequestingForWatchers",false);
		commit("setIsCompanyBuyingServicesOthersSelected",false);
		commit("setBankDetailsDropdownValues",[]);
		commit("setFormValidationErrors",[]);
		commit("resetExceptionSubmissionRequestData");
	},

	async fetchDecisionBranches({ commit,getters }){
		commit("setIsLoading", true);
		let decisionBranches = getters.decisionBranches;

		const response = await Promise.all([api.getlandingSections(), api.getlandingSectionCards(), api.getLandingCardDecisionBranches()]);

		if(!response[0].data.errors
			&& !response[1].data.errors
			&& !response[2].data.errors){
				decisionBranches.sections = response[0].data.data.getAllAppRecords;
				decisionBranches.cards = response[1].data.data.getAllAppRecords;
				decisionBranches.cardDecisionBranches = response[2].data.data.getAllAppRecords;

				commit(
					"setDecisionBranches",
					decisionBranches
				);
				commit("setIsLoading", false);
		}else{
			commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
		}


	},
	async fetchQuickSolutions({ commit, getters }) {
		await this.dispatch("fetchDecisionBranches");
		let decisionBranches = getters.decisionBranches;

		let qs = [];

		if(decisionBranches.cards){
			decisionBranches.cards.forEach((value) => {
				if(value.actionLink){
					qs.push({
						"id":value.id,
						"name": value.name,
						"description": value.description,
						"url": value.actionLink,
						"searchTags":value.searchTags
					});
					
				}
				
			});
		}

		if(decisionBranches.cardDecisionBranches){
			decisionBranches.cardDecisionBranches.forEach((value) => {
				if(value.actionLink){
					qs.push({
						"id":value.id,
						"name": value.name,
						"description": value.description,
						"url": value.actionLink,
						"searchTags":value.searchTags
					});
				}

			});
		}
		
		commit("setQuickSolutions", qs);
	},
	async fetchAllProducts({ commit }, showLoadingSpinner = true) {
		showLoadingSpinner ? commit("setIsLoading", true) : ''
		const response = await api.getAllProducts();
		if (response.data.errors) {
			if (response.data.errors[0].message.indexOf("Access denied") !== -1) {
				let errorPage = "/forbidden";
				if (process.env.VUE_APP_ENVIRONMENT === "LOCAL")
					errorPage = process.env.VUE_APP_EH_URL + "/forbidden";
				location.href = errorPage;
			} else {
				commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
			}
		} else {
			commit("setProducts", response.data.data.fetchAllProducts);
		}
		showLoadingSpinner ? commit("setIsLoading", false) : ''
	},
	async fetchAllSuppliers({ commit }) {
		commit("setIsLoading", true)
		const response = await api.getAllVendors();
		if (response.data.errors) {
			if (response.data.errors[0].message.indexOf("Access denied") !== -1) {
				let errorPage = "/forbidden";
				if (process.env.VUE_APP_ENVIRONMENT === "LOCAL")
					errorPage = process.env.VUE_APP_EH_URL + "/forbidden";
				location.href = errorPage;
			} else {
				commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
			}
		} else {
			let formattedSuppliers = response.data.data.fetchAllVendors

			/*
			* Clean up supplier ID if supplierID consists of leading zeros.
			*/
			formattedSuppliers.forEach((supplier) => {
				if(supplier.supplierId > CONSTANTS.SUPPLIER_ID_MAX_LENGTH) {
					supplier.supplierId = supplier.supplierId.replace(/^0+/, '')
				}
				if(supplier.name.includes(CONSTANTS.PPLUS_DATA_CLEAN_UP)) {
					supplier.name = supplier.name.split(CONSTANTS.PPLUS_DATA_CLEAN_UP).join("")
				}
			})
			commit("setSuppliers", formattedSuppliers);
		}
		commit("setIsLoading", false)
	},
	getAppData({ commit, state }, alias) {
		commit("setIsLoading", true);
		return api
			.getAppdata(alias)
			.then((response) => {
				if (response.data.errors) {
					if (response.data.errors[0].message.indexOf("Access denied") !== -1) {
						let errorPage = "/forbidden";
						if (process.env.VUE_APP_ENVIRONMENT === "LOCAL")
							errorPage = process.env.VUE_APP_EH_URL + "/forbidden";
						location.href = errorPage;
					} else {
						commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
					}
				} else {
					commit(
						"setCurrentAppData",
						response.data.data.getGuidedPlatformAppData
					);
				}
			})
			.finally(() => {
				commit("setIsLoading", false);
			});
	},
	createSupplierOnboardRequest({ commit, state }, supplierOnboardRequest) {
		commit("setIsLoading", true);
		commit("setErrorMessage", null);
		commit("setErrorDetail", null);
		return api
			.createSupplierOnboardRequest(
				supplierOnboardRequest.data,
				supplierOnboardRequest.isDraft
			)
			.then((response) => {
				if (response.data.errors) {
					if(!isDraft)
					{
						commit("setErrorMessage", CONSTANTS.ONE_INTAKE_ERROR_MESSAGE);
						commit("setErrorDetail", response.data.errors[0].message);
					}
					else
					{
						commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
					}	
				} else {
					if (supplierOnboardRequest.isDraft) {
						commit(
							"setDraftId",
							response.data.data.createSupplierOnBoardRequest.id
						);
					} else {
						let caseNumber =
							response.data.data.createSupplierOnBoardRequest.caseNumber;
						let viewCaseUrl =
							response.data.data.createSupplierOnBoardRequest.viewCaseUrl;
						commit("setCaseDetails", {
							caseNumber: caseNumber,
							viewCaseUrl: viewCaseUrl,
						});
					}
				}
			}).catch(() => {
				if(!isDraft)
					{
						commit("setErrorMessage", CONSTANTS.ONE_INTAKE_ERROR_MESSAGE);
						commit("setErrorDetail", response.data.errors[0].message);
					}
					else
					{
						commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
					}	
			})
			.finally(() => {
				commit("setIsLoading", false);
			});
	},
	fetchAllAdminUsers({commit,state},isAdminUserRequired){
		return api.getAllAdminDataList(isAdminUserRequired).then((response) =>{
			if (response.data.errors){
				commit("setErrorMessage",CONSTANTS.ERROR_MESSAGE);
			}else if (response.data.data && response.data.data.fetchAllAdminDataList && response.data.data.fetchAllAdminDataList.supplierDataList && response.data.data.fetchAllAdminDataList.supplierDataList.adminUserList
					&& response.data.data.fetchAllAdminDataList.supplierDataList.adminUserList.length > 0){
					commit("setAdminAPUserList",response.data.data.fetchAllAdminDataList.supplierDataList.adminUserList);
			}
		})
	},
	async getSupplierCountryListData({commit,state}){
		try{
			commit("setIsLoading",true)
			const response = await api.getCountryListForSupplierCountry();
			if (response.data.errors){
				commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
			}else{
				let supplierCountryListData = response.data.result;
				//	Manipulating received data to be able to store it in the way UI expects it
				if(supplierCountryListData && supplierCountryListData.length > 0){
					supplierCountryListData  = supplierCountryListData.map((listItem,index) => {
						return {value: `${index + 1}` , text : listItem.u_country}
					})
				}
				commit("setSupplierCountryList", supplierCountryListData);
			}
		}catch (e) {
			commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
		}finally {
			commit("setIsLoading",false)
		}
	},
	async fetchAllAdminDataRequiredList({commit,state},isAdminUserRequired){

		let adminDataList = {
			companyBusinessPlaceList : [],
			companyCodeList : [],
			countryCodeList :[],
			countryList : [],
			countryStateList : [],
			currencyList : [],
			expenseTypeCodeOptions : [],
			expenseTypeTextOptions : [],
			companyCodeTextOptions: [],
			companyCodeOptions: [],
			bankTypeOfAccount: FORMS_OPTIONS.bankTypeOfAccount,
			paymentTypeOptions: FORMS_OPTIONS.paymentTypeOptions,
		};

		try{
			commit("setIsLoading",true)
			const response = await api.getAllAdminDataList(isAdminUserRequired);

			if (response.data.errors){
				commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
			}else{
				let allAdminRequiredData = response.data.data.fetchAllAdminDataList.supplierDataList;

				//	Manipulating received data to be able to store it in the way UI expects it
				if(allAdminRequiredData && allAdminRequiredData.companyBusinessPlaceList && allAdminRequiredData.companyBusinessPlaceList.length > 0){
					adminDataList.companyBusinessPlaceList  = allAdminRequiredData.companyBusinessPlaceList.map((listItem) => {
						return { text : listItem.businessPlaceText, value: listItem.businessPlace}
					})
				}
				if (allAdminRequiredData && allAdminRequiredData.countryStateList && allAdminRequiredData.countryStateList.length > 0){
					allAdminRequiredData.countryStateList.forEach((listItem) => adminDataList.countryStateList.push(listItem))
				}
				if (allAdminRequiredData && allAdminRequiredData.companyCodeList && allAdminRequiredData.companyCodeList.length > 0){
					adminDataList.companyCodeList = allAdminRequiredData.companyCodeList.map((listItem) => {
						return {companyCode : listItem.companyCode , companyName : listItem.companyName,countryCode : listItem.countryCode, currency : listItem.currency,supplierId : listItem.otvVendorId, isVatMandatory : listItem.vatIdRequired}
					})
					adminDataList.companyCodeTextOptions = allAdminRequiredData.companyCodeList.map((listItem,index) => {
						return {value: `${index + 1}` , text : listItem.companyName}
					})
					adminDataList.companyCodeOptions = allAdminRequiredData.companyCodeList.map((listItem,index) => {
						return  {value: `${index + 1}` , text : listItem.companyCode}
					})
				}
				if (allAdminRequiredData && allAdminRequiredData.currencyList && allAdminRequiredData.currencyList.length > 0){
					adminDataList.currencyList = allAdminRequiredData.currencyList.map((listItem,index) => {
						return {text : listItem.currencyKey , value : listItem.currencyKey , decimal: listItem.decimalPrecision}
					})
				}
				if (allAdminRequiredData && allAdminRequiredData.expenseTypeList && allAdminRequiredData.expenseTypeList.length > 0){
					allAdminRequiredData.expenseTypeList = allAdminRequiredData.expenseTypeList.sort((a,b) => (a.expenseType > b.expenseType) ? 1 : -1 )
					adminDataList.expenseTypeCodeOptions = allAdminRequiredData.expenseTypeList.map((listItem,index) => {
						return {text: listItem.expenseType , value: `${index + 1}`}
					})
					adminDataList.expenseTypeTextOptions = allAdminRequiredData.expenseTypeList.map((listItem,index) => {
						return {text: listItem.expenseDescription , value: `${index + 1}`}
					})
				}
				if (allAdminRequiredData && allAdminRequiredData.countryList && allAdminRequiredData.countryList.length > 0){
					adminDataList.countryList = allAdminRequiredData.countryList.map((listItem) => {
						return {value: listItem.countryKey , text : listItem.countryName}
					})
				}
				if (allAdminRequiredData && allAdminRequiredData.countryCodeList && allAdminRequiredData.countryCodeList.length > 0){
					adminDataList.countryCodeList = allAdminRequiredData.countryCodeList.map((listItem) => {
						return {value: listItem.countryCode , text : listItem.countryName}
					})
				}
			}

			commit("setAdminDataList", adminDataList);
		}catch (e) {
			commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
		}finally {
			commit("setIsLoading",false)
		}
	},
	submitOneTimeSupplierPaymentData({commit, state},submitOneTimeSupplierPaymentRequest){
		commit("setIsLoading", true);
		return api.submitOneTimeSupplierPaymentFormData(
			submitOneTimeSupplierPaymentRequest.data,
			submitOneTimeSupplierPaymentRequest.isDraft
		)
			.then((response) => {
				if (response.data.errors){
					commit("setErrorMessage",CONSTANTS.ERROR_MESSAGE);
				}else {
					if (submitOneTimeSupplierPaymentRequest.isDraft){
						commit("setDraftId",response.data.data.submitOnetimePayment.webformResponse.returnMessages[0].messageId);
					}
				}
			})
			.finally(()=>{
				commit("setIsLoading",false);
			})
	},
	submitPOBasedPaymentData({commit, state},submitPOBasedPaymentDataRequest){
		commit("setIsLoading", true);
		return api.submitPurchaseOrderFormData(
			submitPOBasedPaymentDataRequest.data,
			submitPOBasedPaymentDataRequest.isDraft
		)
			.then((response) => {
				if (response.data.errors){
					commit("setErrorMessage",CONSTANTS.ERROR_MESSAGE);
				}else {
					if (submitPOBasedPaymentDataRequest.isDraft){
						commit("setDraftId",response.data.data.submitPurchaseOrder.webformResponse.returnMessages[0].messageId);
					}
				}
			})
			.finally(()=>{
				commit("setIsLoading",false);
			})
	},
	submitNonPOBasedPaymentData({commit, state},submitNonPOBasedPaymentDataRequest){
		commit("setIsLoading", true);
		return api.submitNonPOBasedFormData(
			submitNonPOBasedPaymentDataRequest.data,
			submitNonPOBasedPaymentDataRequest.isDraft
		)
			.then((response) => {
				if (response.data.errors){
					commit("setErrorMessage",CONSTANTS.ERROR_MESSAGE);
				}else {
					if (submitNonPOBasedPaymentDataRequest.isDraft){
						//Set it for appropriate NON PO Purchase order.
						commit("setDraftId",response.data.data.submitNonPurchaseOrder.webformResponse.returnMessages[0].messageId);
					}
				}
			})
			.finally(()=>{
				commit("setIsLoading",false);
			})
	},
	fetchInvoiceDraftRecords({ commit }){
		return api
			.getInvoiceDraftRecords()
			.then((response) => {
				if (response.data.errors) {
					commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
				}else{
				let drafts = response.data.data.fetchAllDraftWebformRequest;
				if (drafts && drafts.length > 0) {
					drafts.sort(
						(a, b) => new moment(b.updatedOn) - new moment(a.updatedOn)
					);
					commit("setInvoiceDraftRecords", drafts);
				} else {
					commit("setInvoiceDraftRecords", []);
				}
			}
			}).catch(()=>{
				commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
			})
	},
	async fetchUserDrafts({ commit, state }, showSpinner = true) {
		showSpinner ? commit("setIsLoading", true) : '';
		return api
			.getUserDraftData()
			.then((response) => {
				let drafts = response.data.data.fetchSupplierOnBoardDraftRequest;
				if (drafts && drafts.length > 0) {
					drafts.sort(
						(a, b) => new moment(b.updatedOn) - new moment(a.updatedOn)
					);
					commit("setSupplierDraftData", drafts);
				} else {
					commit("setSupplierDraftData", []);
				}
			})
			.finally(() => {
				showSpinner ? commit("setIsLoading", false) : '';
			});
	},
	async fetchAllOnBoardingRequests({ commit, state }, showSpinner = true) {
		showSpinner ? commit("setIsLoading", true) : '';
		const response = await api.getAllOnBoardingRequestStatus();
		let allRequests = response.data.data.fetchAllOnBoardingRequests;


		let pendingRequests = [];
		let completedRequests = [];
		let returnedRequests = [];

		/* Separate completed requests from pending requests and set objects in state */
		if (allRequests && allRequests.length > 0) {
			allRequests.forEach((request) => {
				if (
					request.status === CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.OPEN ||
					request.status === CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.WORK_IN_PROGRESS ||
					request.status === CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.PENDING_APPROVAL
				) {
					pendingRequests.push(request);
				} else if (
					request.status === CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.CLOSED ||
					request.status === CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.RESOLVED_COMPLETE ||
					(request.status === CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.RESOLVED_INCOMPLETE && !request.isRequestedForResubmission)) {
					completedRequests.push(request);
				} else if (request.status === CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.RESOLVED_INCOMPLETE && request.isRequestedForResubmission) {
					returnedRequests.push(request);
				}
			});
		}

		if (pendingRequests && pendingRequests.length > 0) {
			pendingRequests.sort(
				(a, b) => new moment(b.createdOn) - new moment(a.createdOn)
			);
			commit("setOnBoardingPendingRequests", pendingRequests);
		}else {
			commit("setOnBoardingPendingRequests", []);
		}

		if (completedRequests && completedRequests.length > 0) {
			completedRequests.sort(
				(a, b) => new moment(b.createdOn) - new moment(a.createdOn)
			);
			commit("setOnBoardingCompletedRequests", completedRequests);
		} else {
			commit("setOnBoardingCompletedRequests", []);
		}

		if (returnedRequests && returnedRequests.length > 0) {
			returnedRequests.sort(
				(a, b) => new moment(b.createdOn) - new moment(a.createdOn)
			);
			commit("setOnBoardingReturnedRequests", returnedRequests);
		} else {
			commit("setOnBoardingReturnedRequests", []);
		}

		showSpinner ? commit("setIsLoading", false) : '';
	},
	populateUserInfo({ commit, state }, userObj) {
		return api
			.getUserInfo(userObj.userId)
			.then((response) => {
				if (userObj.requestedBy) {
					commit("setAdskContactInfo", response.data);
					commit("setRequestedBy", userObj.userId);
					commit("setFullName", {
						requestedBy: true,
						fullName: response.data.fullName,
					});
				} else {
					commit("setAdskContactInfo", response.data);
					commit("setFullName", {
						requestedBy: false,
						fullName: response.data.fullName,
					});
				}
			})
			.catch(() => {
				commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
			})
	},
	fetchVendorById({ commit, state }, id) {
		commit("setIsLoading", true);
		return api
			.getVendorById(id)
			.then((response) => {
				let fetchedSupplierName = response.data.data.fetchVendorById.name
				if(fetchedSupplierName.includes(CONSTANTS.PPLUS_DATA_CLEAN_UP)) {
					fetchedSupplierName = fetchedSupplierName.split(CONSTANTS.PPLUS_DATA_CLEAN_UP).join("")
				}
				commit("setSupplierName", fetchedSupplierName);
				/* If we are fetching vendor by Id we do not need help with supplier */
				commit("setNeedHelpWithSupplier", false);
				commit("setSupplierNameLoaded", true);
				if (response.data.data.fetchVendorById.website.length > 0) {
					commit(
						"setSupplierWebsite",
						response.data.data.fetchVendorById.website
					);
				}
			})
			.finally(() => {
				commit("setIsLoading", false);
			});
	},
	fetchAdskContactInfo({ commit, state }, id) {
		commit("setIsLoading", false);
		return api
			.getUserInfo(id)
			.then((response) => {
				commit("setAdskContactInfo", response.data);
			})
			.catch(() => {
				commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
			})
			.finally(() => {
				commit("setIsLoading", false);
			});
	},
	async deleteDraftRequestById({ commit, state }, id) {
		commit("setIsLoading", false);
		return api
			.deleteDraftRequestById(id)
			.then(() => {
				commit("setDraftId", "");
			})
			.finally(() => {
				commit("setIsLoading", false);
			});
	},
	deleteInvoiceDraftById({ commit, state }, id) {
		commit("setIsLoading", false);
		return api
			.deleteInvoiceDraftRequestById(id)
			.then((response) => {
				if(response && response.data && response.data.errors) {
					commit("setDeleteDraftErrorMessage", CONSTANTS.DELETE_DRAFT_ERROR_MESSAGE)
				} else {
					commit("setDraftId", "");
				}
			})
			.finally(() => {
				commit("setIsLoading", false);
			});
	},
	async fetchInvoiceDashboardData({dispatch, commit,getters}) {
		commit('setIsLoading', true)
		await dispatch('fetchInvoices');

		if (getters.apUserId && getters.apUserId.length > 0){
			commit("setInvoiceDraftRecords", []);
		}else if (!getters.invoiceDraftRecords || getters.invoiceDraftRecords.length === 0 || getters.isInvoicesAndDraftsCached){
			await dispatch('fetchInvoiceDraftRecords');
			commit('setIsInvoicesAndDraftsCached',false);
		}
		let invoicesDirectReports = await dispatch('getDirectReportsById')
		commit('setInvoicesDirectReports', invoicesDirectReports)
		await dispatch('updateInvoicesRolesList')
		commit('setIsLoading', false)
	},
	async getDirectReportsById({getters}) {
		let userId = getters.viewingAPUserDataFor ? getters.apUserId : getters.currentUser.userName
		let directReports = []
		try {
			let response = await api.getDirectReportsById(userId)
			if(response && response && response.data.directReports && response.data.directReports.length > 0) {
				let directReportsObj = response.data.directReports
				directReportsObj.forEach((report) => {
					directReports.push({ fullName: report.fullName, id: report.userName })
				})
			}
		} catch {
			/* eslint-disable no-console */
			//We can fail silently as we don't have to notify user that directReports api fetch failed.
		}

		return directReports
	},
	async fetchInvoices({ commit ,getters }) {
		let invoiceResponse = ''

		let dateRange = {}
		dateRange.fromDate = moment().subtract(CONSTANTS.MONTHS_WORTH_OF_DASHBOARD_DATA, 'months').format('YYYY-MM-DD')
		dateRange.toDate = moment().format('YYYY-MM-DD')

		try {
			if (getters && getters.apUserId && getters.apUserId.length > 0){
				invoiceResponse = await api.getInvoices(dateRange,getters.apUserId);
			}else{
				invoiceResponse = await api.getInvoices(dateRange);
			}
		} catch {
			commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
		}
		if (!invoiceResponse.data || invoiceResponse.data.errors) {
			commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
		} else {
			let invoices = []
			let trackSubmittedInvoice = []
			if (invoiceResponse && invoiceResponse.data && invoiceResponse.data.data && invoiceResponse.data.data.fetchAllInvoices && invoiceResponse.data.data.fetchAllInvoices.poInvoiceResponse && invoiceResponse.data.data.fetchAllInvoices.poInvoiceResponse.invoices && invoiceResponse.data.data.fetchAllInvoices.poInvoiceResponse.invoices.length > 0){
				invoices = invoiceResponse.data.data.fetchAllInvoices.poInvoiceResponse.invoices;
			}
			if(invoiceResponse && invoiceResponse.data && invoiceResponse.data.data && invoiceResponse.data.data.fetchAllInvoices && invoiceResponse.data.data.fetchAllInvoices.trackSubmittedInvoice && invoiceResponse.data.data.fetchAllInvoices.trackSubmittedInvoice.length > 0){
				trackSubmittedInvoice = invoiceResponse.data.data.fetchAllInvoices.trackSubmittedInvoice;
			}
			let formattedInvoices = [];
			if (invoices && invoices.length > 0) {
				formattedInvoices = invoices.map(function(invoice) {
					var formattedInvoice = Object.assign({}, invoice);
					formattedInvoice.invoiceAmountWithoutCurrency = formattedInvoice.invoiceAmount
					formattedInvoice.invoiceAmount = formattedInvoice.currency
						? "<strong>" + formattedInvoice.currency + "</strong>" + " " + formattedInvoice.invoiceAmount
						: formattedInvoice.invoiceAmount;
					formattedInvoice.invoiceStatus === CONSTANTS.REJECTED_STATUS
						? (formattedInvoice.formattedInvoiceStatus = `<span class='status-rejected'>${formattedInvoice.invoiceStatus}</span>`)
						: (formattedInvoice.formattedInvoiceStatus = `<strong>${formattedInvoice.invoiceStatus}</strong>`);

					formattedInvoice.supplierName = formattedInvoice.supplierName && formattedInvoice.supplierName !== '' && formattedInvoice.supplierName.length > 0 ? formattedInvoice.supplierName : 'N/A'

					// Rejection comments have <NextLine> syntax in them which need to be parsed to <br /> for html.
					formattedInvoice.rejectionComments
						? (formattedInvoice.rejectionComments = formattedInvoice.rejectionComments.replace(
								new RegExp(CONSTANTS.SAP_LINE_SEPARATOR, "g"),
								"<br />"
						  ))
						: (formattedInvoice.rejectionComments = "");


					return formattedInvoice
				})
			}
			await commit("setInvoiceSubmissionStatusRecords",trackSubmittedInvoice)
			await commit("setFormattedInvoices", formattedInvoices);
		}
	},
	async fetchPurchaseOrders({ commit, getters }) {
		let poResponse = ''
		let dateRange = {}
		dateRange.fromDate = moment().subtract(CONSTANTS.MONTHS_WORTH_OF_DASHBOARD_DATA, 'months').format('YYYY-MM-DD')
		dateRange.toDate = moment().format('YYYY-MM-DD')

		try {
			commit("setIsLoading", true)
			if (getters && getters.apUserId && getters.apUserId.length > 0){
				poResponse = await api.getPurchaseOrders(dateRange,getters.apUserId);
			}else{
				poResponse = await api.getPurchaseOrders(dateRange);
			}
		} catch (error) {
			commit("setIsLoading", false)
			commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
		}
		if (poResponse.data.errors) {
			commit("setErrorMessage", CONSTANTS.ERROR_MESSAGE);
		} else {
			let purchaseOrders = poResponse.data.data.fetchAllPurchaseOrders;

			let purchaseOrdersFormattedList = [];

			if (purchaseOrders && purchaseOrders.length > 0) {
				purchaseOrdersFormattedList = await Promise.all(
					purchaseOrders.map(async (purchaseOrder) => {
						var formattedPurchaseOrder = Object.assign({}, purchaseOrder);
						formattedPurchaseOrder.originalStatus = formattedPurchaseOrder.status
						formattedPurchaseOrder.status === CONSTANTS.REJECTED_STATUS
							? (formattedPurchaseOrder.status = `<span class='status-rejected'>${formattedPurchaseOrder.status}</span>`)
							: (formattedPurchaseOrder.status = `<strong> ${formattedPurchaseOrder.status} </strong>`);

						formattedPurchaseOrder.supplierName =
							formattedPurchaseOrder.supplierName
							&& formattedPurchaseOrder.supplierName !== ''
							&& formattedPurchaseOrder.supplierName.length > 0 ? formattedPurchaseOrder.supplierName : 'N/A'

						formattedPurchaseOrder.netValueInUsd ? formattedPurchaseOrder.purchaseOrderAmountinUSD = `<strong>USD </strong><span>${formattedPurchaseOrder.netValueInUsd}</span>` : ''
						formattedPurchaseOrder.netValue ? formattedPurchaseOrder.purchaseOrderAmount = `<strong>${formattedPurchaseOrder.poCurrency}</strong><span> ${formattedPurchaseOrder.netValue}</span>` : ''


						return formattedPurchaseOrder;
					})
				);
			}

			await commit(
				"setPurchaseOrdersFormattedList",
				purchaseOrdersFormattedList
			);
			commit("setIsLoading", false)

		}
	},
	async fetchInvoicesAndPurchaseOrders({commit, dispatch, getters}) {
		if(!getters.purchaseOrdersFormattedList || getters.purchaseOrdersFormattedList.length === 0 || !getters.formattedInvoices || getters.formattedInvoices.length === 0) {
			commit("setIsLoading", true)
			await Promise.all([dispatch('fetchPurchaseOrders'), dispatch('fetchInvoiceDashboardData')])
			commit("setIsLoading", false)
		}
	},

	resetInvoiceRoleFilters({commit}) {
		let INVOICE_FILTER_ROLES = {
			NON_PO_INVOICES_FILTER: {
				INVOICES_GROUP_TITLE: "Invoices",
				INVOICES_SUBMITTED_BY_ME_STRING: "Submitted by me",
				INVOICES_SUBMITTED_BY_MY_DIRECT_REPORTS: "Submitted by my direct reports"
			},
			PO_INVOICES_FILTER: {
				PURCHASE_ORDERS_GROUP_TITLE: "Purchase orders",
				INVOICES_FOR_MY_COST_CENTER_PO: "Cost center owner",
				INVOICES_FOR_PO_CREATED_BY_ME: "Created by me",
				INVOICES_FOR_PO_CREATED_BY_MY_DIRECT_REPORTS: "Created by my direct reports",
				INVOICES_FOR_COST_CENTER_FBP_PO: "Cost center finance business partner",
				INVOICES_FOR_PO_REQUESTED_BY_ME: "Requested by me",
				INVOICES_FOR_PO_SUBMITTED_BY_MY_DIRECT_REPORTS: "Requested by my direct reports"
			}
		}
		commit("setInvoicesFilterRoles", INVOICE_FILTER_ROLES)
	},
	updateInvoicesRolesList({dispatch, getters, commit}) {
		dispatch('resetInvoiceRoleFilters')
		let userId = getters.viewingAPUserDataFor ? getters.apUserId : getters.currentUser.userName

		let INVOICES_FILTER_ROLES = getters.INVOICES_FILTER_ROLES

		if (!getters.invoicesDirectReports || getters.invoicesDirectReports.length === 0) {
			delete INVOICES_FILTER_ROLES.NON_PO_INVOICES_FILTER.INVOICES_SUBMITTED_BY_MY_DIRECT_REPORTS
			delete INVOICES_FILTER_ROLES.PO_INVOICES_FILTER.INVOICES_FOR_PO_CREATED_BY_MY_DIRECT_REPORTS
			delete INVOICES_FILTER_ROLES.PO_INVOICES_FILTER.INVOICES_FOR_PO_SUBMITTED_BY_MY_DIRECT_REPORTS
		}
		if (!(getters.formattedInvoices
			&& getters.formattedInvoices.length > 0
			&& getters.formattedInvoices.some(invoice => invoice.purchaseOrders
				&& invoice.purchaseOrders.some(po => po && po.poAdditionalData && po.poAdditionalData.length > 0
					&& po.poAdditionalData.some(additionalData => additionalData.costCenterOwner === userId))))) {
			delete INVOICES_FILTER_ROLES.PO_INVOICES_FILTER.INVOICES_FOR_MY_COST_CENTER_PO
		}
		if (!(getters.formattedInvoices
			&& getters.formattedInvoices.length > 0
			&& getters.formattedInvoices.some(invoice => invoice.purchaseOrders
				&& invoice.purchaseOrders.some(po => po && po.poAdditionalData && po.poAdditionalData.length > 0
					&& po.poAdditionalData.some(additionalData => additionalData.costCenterFbp === userId))))) {
			delete INVOICES_FILTER_ROLES.PO_INVOICES_FILTER.INVOICES_FOR_COST_CENTER_FBP_PO
		}

		let rolesList = JSON.parse(JSON.stringify([...Array.from(Object.values(INVOICES_FILTER_ROLES.NON_PO_INVOICES_FILTER)), ...Array.from(Object.values(INVOICES_FILTER_ROLES.PO_INVOICES_FILTER))]))
		commit("setInvoicesRolesList", rolesList)
	}
};
const store = new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
});

export default store;
